<div style="text-align: center; padding: 4rem;">
    <h1>Access Denied</h1>
    <p>You do not have permission to view this page.</p>
    <a href="#" (click)="handleLogout($event)">
      Go Home
    </a>
  </div>
  